import React from "react";
import { compose } from "redux";
import { TextField } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

const TextFieldColumnField = ({ classes, input, ...rest }) => {
  const { value, onChange } = input;

  return (
    <TextField
      fullWidth
      value={value}
      onChange={onChange}
      InputProps={{
        disableUnderline: true,
        classes: {
          root: classes.textField,
        },
      }}
      inputProps={{
        className: classes.inputField,
      }}
      {...rest}
    />
  );
};

const styles = theme => ({
  textField: {
    ...theme.typography.body2,
    height: "100%",
    "& .MuiSelect-icon": {
      display: "none",
    },
    "&:hover": {
      background: grey[200],
    },
    "&:hover .MuiSelect-icon": {
      display: "initial",
    },
  },
  inputField: {
    "&:focus": {
      background: grey[200],
    },
    "&:focus ~ .MuiSelect-icon": {
      display: "initial",
    },
  },
});

export default compose(withStyles(styles))(TextFieldColumnField);
